import "./MainLoader.scss";
import React from "react";
const MainLoader = () => {
  return <div className="LoaderWrapper"></div>;
};

export default MainLoader;
